module.exports = __webpack_public_path__ + "assets/img/00116.119f13f6.png";